import React from "react";
import { useNavigate } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import image1 from "../../images/commentcamarche/image_presta.png"; // Waiter image

interface CallToActionHeaderProps {
  title?: string;
  highlightText?: string;
  description?: string;
  buttonText?: string;
  buttonAction?: () => void;
  imageSrc?: string;
  highlightTextColor?: string;
  imageWidth?: string;
  imageHeight?: string;
  bg?: string;
  Htitle?: keyof JSX.IntrinsicElements;
}
const CallToActionHeader: React.FC<CallToActionHeaderProps> = ({
  Htitle = "h1",
  title = "Proposez vos prestations événementielles et gagnez en visibilité",
  highlightText = "prestations",
  description = `Vous êtes prestataire événementiel à Paris, en Île-de-France  et partout en France? Rejoignez EventToBee, la plateforme dédiée aux professionnels de l’événementiel souhaitant gagner en visibilité et trouver de nouveaux clients.
Que vous soyez traiteur, photographe, DJ, décorateur, animateur ou spécialiste du team building, proposez vos prestations événementielles en quelques clics. Grâce à notre outil de publication simple et efficace, vous pouvez décrire vos services, ajouter vos tarifs, et recevoir des demandes de particuliers ou d’entreprises directement.

✔️ Développez votre activité événementielle
✔️ Présentez votre savoir-faire
✔️ Attirez des clients qualifiés à Paris et en région`,
  buttonText = "S'inscrire",
  buttonAction,
  imageSrc = image1,
  highlightTextColor = "bg-eventToBeePink",
  imageWidth = "w-full",
  imageHeight = "h-full",
  bg = "bg-gradient-to-br",
}) => {
  const navigate = useNavigate();
  const defaultAction = () => navigate("/signup/service");

  return (
    <div
      className={`flex items-center justify-center p-6 ${bg} from-gray-50 to-gray-200 dark:bg-neutral-900 dark:from-neutral-800`}
    >
      <div className="flex flex-col w-full gap-8 max-w-7xl md:flex-row">
        {/* Left Section: Text and Button */}
        <div className="flex-1 space-y-6">
          <Htitle className="text-6xl font-extrabold leading-tight text-gray-900 md:text-6xl lg:text-6xl dark:text-white">
            {title.split(highlightText).map((part, index, array) =>
              index < array.length - 1 ? (
                <span key={index}>
                  {part}
                  <span className="relative inline-block text-6xl">
                    {highlightText}
                    <span
                      className={`absolute left-0 w-3/4 h-2 text-6xl ${highlightTextColor} rounded-full bottom-1`}
                    ></span>
                  </span>
                </span>
              ) : (
                part
              )
            )}
          </Htitle>
          <p className="mt-4 text-lg leading-relaxed text-gray-600 dark:text-white">
            {description.split("\n").map((line, index) => (
              <p key={index} className="mb-4">
                {line}
              </p>
            ))}
          </p>
          <ButtonSecondary
            className="px-8 py-3 mt-4 text-lg font-medium text-gray-800 transition-all bg-white border border-gray-300 rounded-full"
            onClick={buttonAction || defaultAction}
          >
            {buttonText}
          </ButtonSecondary>
        </div>

        {/* Right Section: Image Grid */}
        <div className="">
          <div className="overflow-hidden rounded-lg">
            <div className="relative w-full h-full">
              <img
                src={imageSrc}
                alt="Call to action image"
                className={`object-cover ${imageHeight} ${imageWidth}  rounded-lg`}
              />
              <div className="absolute bottom-0 right-0 w-1/2 h-1/2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToActionHeader;
